import { render, staticRenderFns } from "./EditMajority.vue?vue&type=template&id=461def8c&"
import script from "./EditMajority.vue?vue&type=script&lang=js&"
export * from "./EditMajority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports